import { Icon as LegacyIcon } from '@ant-design/compatible'
import {
  ExclamationCircleOutlined,
  InfoCircleOutlined,
  QuestionCircleOutlined
} from '@ant-design/icons'
import mainStore from '@components/Main/store'
import { getObjValue, switchCase } from '@hlj/hlj-utils'
import { HeaderView } from '@merchant-backend/common-components'
import { Button, Modal, Tooltip } from 'hljd'
import { observer } from 'mobx-react'
import React, { Component } from 'react'
import { hashHistory } from 'react-router'
import List from './List'
import store from './store'
import styles from './style.module.less'

@observer
export default class extends Component {
  constructor(props) {
    super(props)
    const {
      location: {
        query: { errno }
      }
    } = props

    store.statusAuthorize = +errno

    if (+errno === 1 || +errno === 2 || +errno === 3) {
      store.failVisible = true
    }
  }

  componentDidMount() {
    store.judgeOvertime()
    store.getStatistics()
  }

  handleClose = () => {
    store.close('shareVisible')
    hashHistory.push('/')
  }

  render() {
    const {
      merchantInfo: { name },
      shopInfo: { merchant_weapp }
    } = mainStore
    const {
      visible,
      total,
      list,
      shareVisible,
      vipVisible,
      audit_version,
      home_wxacode,
      merchant_wxacode,
      statistics: { example_uv, home_uv, package_uv, total_pv, total_uv },
      visibleUpdate,
      failVisible,
      downVisible,
      statusAuthorize,
      visibleTips
    } = store

    let _home_wxacode = home_wxacode || sessionStorage.getItem('home_wxacode')
    let _merchant_wxacode =
      merchant_wxacode || sessionStorage.getItem('merchant_wxacode')

    let icon = (
      <a
        style={{ color: '#ff801a', paddingLeft: 40 }}
        href="https://m.hunliji.com/p/wedding/Public/wap/m/business-school-detail/index.html?id=125"
        target="_blank"
        rel="noopener noreferrer"
      >
        <img
          src="http://qnm.hunliji.com/o_1cfei9hh8v8411gfklj190l36m7.png"
          style={{ verticalAlign: '-4px' }}
        />{' '}
        使用说明
      </a>
    )

    let title_modal = '小程序'
    let title = <span>小程序 {icon}</span>
    if (getObjValue(merchant_weapp, 'type') == '1') {
      title = <span>小程序 {icon}</span>
      title_modal = '小程序'
    } else {
      title = <span>小程序 {icon}</span>
      title_modal = '小程序'
    }

    let show = list.length > 0

    let downloadImg = _merchant_wxacode
      ? _merchant_wxacode.indexOf('?') > 0
        ? _merchant_wxacode
        : _merchant_wxacode + '?imageView2/2/w/430'
      : ''

    return (
      <HeaderView
        title={title}
        extra={
          !(
            getObjValue(merchant_weapp, 'type') == '2' &&
            getObjValue(merchant_weapp, 'auth_status') == '1'
          ) ? (
            <Button
              type="primary"
              onClick={() =>
                hashHistory.push('/localMerchant/liteApp/authorize')
              }
            >
              升级小程序
            </Button>
          ) : null
        }
      >
        <ul className={styles.top}>
          <li>
            <p className={styles.title}>商家小程序</p>
            <div className={styles.box}>
              <p className={styles.name}>
                商家名称：{name}
                {getObjValue(audit_version, 'audit_info.status') == '2' && (
                  <a
                    style={{ color: '#04964d', float: 'right' }}
                    href="#/localMerchant/liteApp/audit"
                  >
                    微信平台审核中
                  </a>
                )}
                {getObjValue(audit_version, 'audit_info.status') == '1' && (
                  <a
                    style={{
                      color: '#ff5c5c',
                      float: 'right',
                      fontWeight: 'normal'
                    }}
                    href="#/localMerchant/liteApp/audit"
                  >
                    <Tooltip
                      placement="topLeft"
                      title={getObjValue(audit_version, 'audit_info.reason')}
                      arrowPointAtCenter
                    >
                      微信平台审核不通过<QuestionCircleOutlined
                        style={{ marginLeft: 6 }}
                      />
                    </Tooltip>
                  </a>
                )}
              </p>
              <p className={styles.time}>
                使用有效期：至{getObjValue(merchant_weapp, 'server_end') &&
                  getObjValue(merchant_weapp, 'server_end').substring(0, 10)}
              </p>
              {_home_wxacode ? (
                <img src={_home_wxacode} />
              ) : (
                <div className={styles.likeImg} />
              )}
              <p style={{ fontWeight: 'bold' }}>扫码进入小程序操作页</p>
              <div className={styles.btn}>
                {getObjValue(merchant_weapp, 'type') == '2' && (
                  <Button type="primary">
                    <a href="#/localMerchant/liteApp/audit">管理配置</a>
                  </Button>
                )}
                <Button
                  style={{ marginLeft: 10 }}
                  onClick={store.show('downVisible')}
                >
                  小程序码
                </Button>
              </div>
            </div>
          </li>
          <li>
            <p className={styles.title}>
              昨日数据概况
              {getObjValue(merchant_weapp, 'type') == '2' && (
                <a
                  style={{ float: 'right' }}
                  href="https://mp.weixin.qq.com/"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  进入微信后台查看数据
                </a>
              )}
            </p>
            <div className={styles.box} style={{ padding: 40 }}>
              <ul className={styles.data} style={{ marginBottom: 45 }}>
                <li>
                  <p>总浏览次数</p>
                  <p>{total_pv || '-'}</p>
                </li>
                <li>
                  <p>总浏览人数</p>
                  <p>{total_uv || '-'}</p>
                </li>
                <li />
              </ul>
              <ul className={styles.data}>
                <li>
                  <p>主页浏览人数</p>
                  <p>{home_uv || '-'}</p>
                </li>
                <li>
                  <p>案例浏览人数</p>
                  <p>{example_uv || '-'}</p>
                </li>
                <li>
                  <p>套餐浏览人数</p>
                  <p>{package_uv || '-'}</p>
                </li>
              </ul>
            </div>
          </li>
        </ul>

        <div style={{ marginTop: 45, marginBottom: 16 }}>
          <span className={styles.title}>
            内部成员({total})&nbsp;&nbsp;
            <Tooltip
              placement="topLeft"
              title="成为商家的内部成员后，即可在访问相应的商家小程序页面时，激活内容快捷分享功能。 可以将商家主页、案例、套餐直接通过小程序分享给客户，提高体验和效率。"
            >
              <QuestionCircleOutlined style={{ cursor: 'pointer' }} />
            </Tooltip>
          </span>
          <Button type="primary" style={{ float: 'right' }} onClick={store.add}>
            增加成员
          </Button>
        </div>

        <div style={{ display: show ? 'block' : 'none' }}>
          <List />
        </div>

        <div
          className={styles.empty}
          style={{ display: !show ? 'block' : 'none' }}
        >
          <ul>
            <li>微信昵称</li>
            <li>真实姓名</li>
            <li>加入时间</li>
            <li>操作</li>
          </ul>
          <div className={styles.img}>
            <img src="http://qnm.hunliji.com/o_1ce906o7iu7m2rkubi1e8jvf97.jpg" />
            <p>成为内部成员，将激活「内容快捷分享功能」</p>
          </div>
        </div>

        <Modal visible={visible} onCancel={store.add} width={460} footer={null}>
          <div className={styles.qcode}>
            <p className={styles.p1}>微信扫码加入</p>
            <p>
              {name} {title_modal}
            </p>
            {_home_wxacode ? (
              <img src={_home_wxacode} />
            ) : (
              <div className={styles.likeBigImg} />
            )}
            <p className={styles.p2}>
              小贴士：加入后，将激活「内容快捷分享功能」
            </p>
          </div>
        </Modal>

        <Modal
          visible={shareVisible}
          onCancel={this.handleClose}
          onOk={store.toPro}
          width={460}
          closable={false}
          okText="续费"
        >
          <div className={styles.overtime}>
            <p>
              <ExclamationCircleOutlined
                style={{ fontSize: 16, color: 'orange', marginRight: 10 }}
              />
              商家服务（付费）已到期，小程序在微信中已无法正常使用
            </p>
            <p className={styles.tips}>续费成功后，可以继续使用。</p>
          </div>
        </Modal>

        <Modal
          visible={vipVisible}
          onCancel={store.close('vipVisible')}
          onOk={store.toVip}
          width={460}
          closable={false}
          okText="续费"
        >
          <div className={styles.overtime}>
            <p>
              <ExclamationCircleOutlined
                style={{ fontSize: 16, color: 'orange', marginRight: 10 }}
              />
              小程序已到期，在微信中已无法正常使用
            </p>
            <p className={styles.tips}>续费成功后，可以继续使用。</p>
          </div>
        </Modal>

        <Modal
          title="小程序老用户升级说明"
          visible={visibleUpdate}
          closable={false}
          footer={
            <div style={{ textAlign: 'center' }}>
              <Button type="primary">
                <a
                  target="_blank"
                  rel="noopener noreferrer"
                  href="https://m.hunliji.com/p/wedding/Public/hlj-m/business-school/index.html?id=65"
                >
                  了解如何操作升级
                </a>
              </Button>
            </div>
          }
          width={500}
          onCancel={store.cancelQrCode}
        >
          <p style={{ fontSize: 14 }}>
            原婚礼纪小程序已全新升级为
            小程序，保留店铺展示服务的同时，增加全新的便捷分享和数据统计等功能。建议您重新授权婚礼纪为您生成全新的小程序。
          </p>
          <p style={{ fontSize: 14, margin: '20px 0 40px 0' }}>
            如果不授权升级，将无法修改小程序配置，原小程序仍可使用
          </p>
        </Modal>

        <Modal
          visible={failVisible}
          title={
            <p style={{ fontSize: 16 }}>
              <LegacyIcon
                type={'close-circle'}
                style={{
                  color: '#f04134',
                  fontSize: 18,
                  marginRight: 10,
                  verticalAlign: 'bottom'
                }}
              />授权失败
            </p>
          }
          maskClosable={false}
          closable={false}
          width={400}
          footer={[
            <Button key="submit" type="primary" onClick={store.getAuth}>
              重新授权
            </Button>
          ]}
        >
          <p style={{ height: 50, fontSize: 14 }}>
            {switchCase(statusAuthorize + '', {
              '1':
                '权限不足，请重新授权。需要授予的权限：账号管理权限、开发管理与数据分析权限。',
              '2': '授权过程出错，请重新授权！',
              '3':
                '信息填写出错，请检查小程序类目是否正常填写(需要与实际经营范围一致)，以及小程序昵称、头像、简介是否正常填写。 如仍有疑问，请联系婚礼纪客服。'
            })}
          </p>
        </Modal>

        <Modal
          visible={visibleTips}
          title={
            <p style={{ fontSize: 16 }}>
              <InfoCircleOutlined
                style={{
                  color: '#448afc',
                  fontSize: 18,
                  marginRight: 10,
                  verticalAlign: 'bottom'
                }}
              />提示
            </p>
          }
          maskClosable={false}
          onCancel={store.cancel('visibleTips')}
          width={400}
          footer={[
            <Button key="back" onClick={store.getAuth}>
              遇到问题，重试
            </Button>,
            <Button key="submit" type="primary" onClick={store.doneAuth}>
              已完成授权
            </Button>
          ]}
        >
          <p style={{ height: 50, fontSize: 14 }}>
            请在新窗口中完成微信小程序授权
          </p>
        </Modal>

        <Modal
          visible={downVisible}
          onCancel={store.close('downVisible')}
          footer={null}
        >
          <div className={styles.tipBox}>
            <p className={styles.p3}>商家主页小程序码</p>
            <p className={styles.p4}>
              小贴士：可以将小程序码，添加到公众号、图片、海报等宣传资料中，客户扫码即可获得服务
            </p>
            <div style={{ marginBottom: 16 }}>
              <img src={_merchant_wxacode} />
            </div>
            <a
              href={downloadImg}
              download="qrcodeImg"
              target="_blank"
              rel="noopener noreferrer"
            >
              <Button style={{ marginLeft: 10 }} type="primary">
                下载图片
              </Button>
            </a>
          </div>
        </Modal>
      </HeaderView>
    )
  }
}
